export default __webpack_public_path__ + "static/media/PilotLogo.5ce1866e.png";